import { Component, OnInit, Input, Output, OnChanges, EventEmitter, OnDestroy, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { saveAs } from 'file-saver';
import { EventServicesService } from 'src/app/services/event-services.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { FormBuilderService } from 'src/app/services/form-builder.service';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { JobServicesService } from 'src/app/services/job-services.service';
import { SharedServicesService } from 'src/app/services/shared-services.service';
import { FormModel, FormSection as Section, FormField as Field, FieldProperties, ElementType } from 'src/app/form-builder/form.types';

export interface Dependancy {
  dependantOn: string,
  dependantValues: Array<string>
}

export interface FieldOptions {
  label: string,
  value: any
}

@Component({
    selector: 'app-feedback-form',
    templateUrl: './feedback-form.component.html',
    styleUrls: ['./feedback-form.component.css'],
    standalone: false
})
export class FeedbackFormComponent implements OnInit, OnChanges, OnDestroy {

  @Input() formUuid: string = '';
  @Input() headerData: any;
  @Input() candidateDetails: any;
  @Input() feedbackMode: string = 'create'; // 'create', 'view', 'edit'
  @Input() onlyFeedbackView: boolean = false;
  @Output() isLoadingFeedback = new EventEmitter<boolean>();
  @Output() closeFeedbackSlider = new EventEmitter<boolean>();
  @Output() downloadFeedbackEvent = new EventEmitter<void>();
  @Output() panelMembersLoaded = new EventEmitter<any[]>();
  private skipDataPopulation = false;

  templateModels: Array<FormModel> = [];
  templateCollections: Array<Array<FormModel>> = [];
  feedbackCollections: Array<any> = [];
  feedbackForm: Array<FormModel> = [];
  invalidField: any;
  templateData: any;
  scoreSections: Array<string> = ['Learnability', 'Project', 'Java Programming Concepts', 'Python Programming Concepts', 'Database Concepts', 'Data Structures and Algorithms Concepts'];
  formName: string = 'Feedback Form';
  pageNumber: number = 1;
  signedProfileUrl: string = '';

  clicked: boolean = false;
  isFormValid: boolean = false;
  submitBtnLoading = false;
  submitted: boolean = false;
  isLoading: boolean = false;
  displayFeedback: boolean = true;
  ansChange: any;
  userDetails: any;
  interrogatorDetails: any;
  dateFormat: any;
  timeFormat: any;
  combinedFormat: any;
  fieldRemoved: any = [];
  formData: any;
  feedbackData: any;
  showForm: boolean = false;
  submissionId: number = 0;
  candidateUuid: any;
  interviewMode: string = '';
  feedbackSubmitted: boolean = false;
  feedbackStatus: boolean = false;

  offlinePanelMembers: any[] = [];
  selectedOfflinePanelMemberId: number | null = null;
  selectedOfflinePanelMemberFormId: number | null = null;
  offlineOriginalFeedbackMode: string = 'create';
  isViewOnlyFeedbackOffline: boolean = false;
  loadingOfflinePanelMembers: boolean = false;
  currentUserIdOffline: number | null = null;
  currentUserNameOffline: string = 'You';

  // Change tracking
  hasChanges: boolean = false;
  originalAnswers: any = {};
  markAsTouced: Subject<void> = new Subject<void>();
  
  // Prevent duplicate API calls
  private isTemplatesLoading = false;
  private isFeedbackDataLoading = false;

  // formName: string = '';

  constructor(
    private formBuilderServices: FormBuilderService,
    private messageServices: MessageService,
    private jobService: JobServicesService,
    private eventServices: EventServicesService,
    private globalService: GlobalServicesService,
    public  sanitizer: DomSanitizer,
    private activatedRoute : ActivatedRoute,
    private router: Router,
    private sharedService: SharedServicesService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.date_format : '';
    this.timeFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.time_format : '';
    this.combinedFormat = this.timeFormat == 'hh:mm' ? this.dateFormat  + '  '+ this.timeFormat + ' a' : this.dateFormat  + '  '+ this.timeFormat;
    
    this.userDetails = localStorage.getItem('userDetails')
      ? JSON.parse(localStorage.getItem('userDetails') || '')
      : '';

      this.activatedRoute.queryParams.subscribe(params => {
        if (params['form_uuid'] && params['interview_mode'] === 'Offline') {
            this.interviewMode = params['interview_mode'];
            this.candidateUuid = params['candidate_uuid'];
            this.formUuid = params['form_uuid'];
            this.feedbackStatus = params['feedback_status'] === 'true' ? true : false;
            this.feedbackMode = params['feedback_status'] === 'true' ? 'edit' : 'create';
            this.isLoading = true;
            this.jobService.getCandidateInfo(this.candidateUuid, params['event_uuid'], false).subscribe({
                next: (response: any) => {
                    if (response.status === 200) {
                      const candidate = response.body.candidate_details || {};
                      const event_uuid = candidate.event_uuid || "";

                      const candidate_name = [candidate.first_name, candidate.last_name]
                        .filter(Boolean)
                        .join(" ");

                      this.candidateDetails = {
                        interview_uuid: params['interview_uuid'],
                        candidate_name: candidate_name,
                        candidate_uuid: candidate.candidate_uuid,
                        candidate_email: candidate.email_id,
                        mobile_number: candidate?.mobile_number?.toString()?.trim() || '',
                        stage_uuid: params['stage_uuid'],
                        event_uuid: event_uuid
                      }
                      };
                    this.offlineOriginalFeedbackMode = this.feedbackMode;
                    this.currentUserIdOffline = this.userDetails?.id != null ? Number(this.userDetails.id) : null;
                    this.currentUserNameOffline = [this.userDetails?.first_name, this.userDetails?.last_name].filter(Boolean).join(' ') || this.userDetails?.name || 'You';
                    const meta = this.globalService.getCurrentUserMeta?.() ?? null;
                    const profile = meta?.user_profile;
                    if (profile?.id != null) {
                      this.currentUserIdOffline = Number(profile.id);
                      this.currentUserNameOffline = [profile.first_name, profile.last_name].filter(Boolean).join(' ') || profile.name || 'You';
                    }
                    this.loadOfflinePanelMembers();
                    },
                error: (error: any) => {
                    this.router.navigate(['/error'], {}).then(() => {
                        this.messageServices.add({
                          severity: 'error',
                          summary: 'Error',
                          detail: 'Failed to load candidate details, Check the candidate UUID or event UUID.'
                        });
                    });
                }
            });
        } else {
            // 
        }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['candidateDetails'] && this.candidateDetails && this.candidateDetails.event_uuid && this.formUuid) {
      this.skipDataPopulation = false;
      this.isTemplatesLoading = false;
      this.isFeedbackDataLoading = false;
      this.showForm = false;
      this.getTemplates();
      this.setProfileImage();
    } else if (changes['feedbackMode'] && this.feedbackMode && this.candidateDetails && this.candidateDetails.event_uuid) {
      this.showForm = false;
      this.skipDataPopulation = false;
      this.isTemplatesLoading = false;
      this.getTemplates();
    }
    if(!this.candidateDetails) this.clicked = false;
  }

  getTemplates = () => {    
    if (!this.candidateDetails || !this.candidateDetails.event_uuid || !this.formUuid) {
      console.error('Missing required data for getTemplates:', { candidateDetails: this.candidateDetails, formUuid: this.formUuid });
      return;
    }
    
    if (this.isTemplatesLoading) {
      return; // Prevent duplicate calls
    }
    
    this.isTemplatesLoading = true;
    this.isLoading = true;
    this.isLoadingFeedback.emit(true);
    this.showForm = false;
    this.cdr.detectChanges();

    this.formBuilderServices.getEventFormDetailsFastApi(this.candidateDetails.event_uuid, this.formUuid).subscribe({
      next: (res: any) => {
        this.formData = res.body;
        this.templateCollections = [];
        
        this.fieldRemoved = []
        this.formData.form_fields.forEach((section: Section) => {
          const sectionFields: FormModel[] = [];
          
          section.section_form_fields?.forEach((field: Field) => {
            if (field.element_type === 'field') {
              sectionFields.push(this.createFieldModel(field, section, this.formData.name));
            } else if (field.element_type === 'group' && field.form_fields) {
              if (field.name === 'primary_number' || field.name === 'primary_number' || field.name === 'parent_number') {
                const filteredFields = field.form_fields.filter(f => f.name !== 'country_code');
                filteredFields.forEach((groupField: Field) => {
                sectionFields.push(this.createFieldModel(groupField, section, this.formData.name, field.name));
                this.fieldRemoved.push('country_code')
                });
              } else {
                field.form_fields.forEach((groupField: Field) => {
                sectionFields.push(this.createFieldModel(groupField, section, this.formData.name, field.name));
                });
              }
            }
          });
    
          if (sectionFields.length > 0) {
            this.templateCollections.push(sectionFields);
          }
        });
        if (this.feedbackMode === 'view' || this.feedbackMode === 'edit') {
          this.isTemplatesLoading = false;
          this.getFeedbackData();
        } else {
          this.isLoading = false;
          this.isTemplatesLoading = false;
          this.showForm = true;
          this.trackOriginalAnswers();
          this.isLoadingFeedback.emit(false);
          this.loadPanelMembersOnly();
          this.cdr.detectChanges();
        }

        this.updateDependentField();
        this.reEvaluateDependenciesAfterPrefill();
      },
      error: (err) => {
        console.error(err);
        this.isTemplatesLoading = false;
        this.isLoading = false;
        this.isLoadingFeedback.emit(false);
        this.cdr.detectChanges();
      }
    });
  }

  private createFieldModel(field: Field, section: Section, formName: string, groupName?: string): FormModel {
    const model: FormModel = {
      fieldId: field.id.toString(),
      fieldOrder: field.order_no,
      fieldName: field.label,
      fieldValue: field.name,
      fieldDescription: field.description,
      isMandatory: field.type.toLowerCase() === 'paragraph' ? false : field.is_required,
      formName: formName,
      displaySection: section.section_label,
      placeHolder: field.placeholder || '',
      fieldType: field.type.toLowerCase(),
      fieldOptions: field.options || [],
      answer: [],
      isValid: field.type.toLowerCase() === 'paragraph' ? true : !field.is_required,
      readOnly: false,
      visible: true,
      disabled: false,
      dependencies: field.dependencies,
      fileProperities: {
        file_format: field.properties?.file_format || [],
        file_max_size: field.properties?.file_max_size || '2MB'
      },
      element_type: (groupName && groupName !== 'primary_number' && groupName !== 'mobile_number' && groupName !== 'secondary_number' && groupName !== 'parent_number') ? 'group' : (field.element_type || 'field'),
      section_label: field.section_label
    };

    if (groupName) {
      model.groupName = groupName;
    }
    return model;
  }

  getFeedbackData() {
    if (this.isFeedbackDataLoading) {
      return;
    }
    this.isFeedbackDataLoading = true;
    this.cdr.detectChanges();
    const formId = this.candidateDetails?.form_id;
    if (formId != null) {
      this.loadFormDetailsByFormId(formId);
      return;
    }
    this.eventServices.getFeedbackTestDetailsFastApi(this.candidateDetails.event_uuid, this.candidateDetails.candidate_uuid).subscribe({
      next: (res: any) => {
        if (res.body.feedback_details && res.body.feedback_details.length > 0) {
          const panelEntries = this.candidateDetails.showAllInterviews
            ? res.body.feedback_details.filter(
                (f: any) => f.stage_uuid === this.candidateDetails.stage_uuid
              )
            : (this.candidateDetails.interview_uuid
                ? res.body.feedback_details.filter(
                    (f: any) => f.interview_uuid === this.candidateDetails.interview_uuid
                  )
                : res.body.feedback_details.filter(
                    (f: any) => f.stage_uuid === this.candidateDetails.stage_uuid
                  ));
          this.panelMembersLoaded.emit(panelEntries);
          if (this.skipDataPopulation) {
            this.isFeedbackDataLoading = false;
            this.isLoading = false;
            this.isLoadingFeedback.emit(false);
            this.cdr.detectChanges();
            return;
          }

          const interviewFeedback = this.candidateDetails.interview_uuid
            ? res.body.feedback_details.filter(
                (f: any) => f.interview_uuid === this.candidateDetails.interview_uuid
              )
            : res.body.feedback_details.filter(
                (f: any) => f.stage_uuid === this.candidateDetails.stage_uuid
              );
          const matchingFeedback = this.candidateDetails.form_id
            ? res.body.feedback_details.find((f: any) => f.form_id === this.candidateDetails.form_id)
            : interviewFeedback[0];

          if (matchingFeedback) {
            this.submissionId = matchingFeedback.form_id;
            this.loadFormDetailsByFormId(this.submissionId);
          } else {
            this.setEmptyFormReady();
          }
        } else {
          this.setEmptyFormReady();
        }
      },
      error: (err) => {
        console.error('Error fetching feedback data:', err);
        this.setEmptyFormReady();
      }
    });
  }

  private loadFormDetailsByFormId(formId: number) {
    this.submissionId = formId;
    this.jobService.getCandidateFormDetails(this.candidateDetails.event_uuid, 'feedback', formId).subscribe({
      next: (response: any) => {
        const details = response.body?.candidate_details ?? response.body;
        if (details && typeof details === 'object') {
          this.feedbackData = details;
          this.populateFormFromFeedbackData(details);
        }
        this.isLoading = false;
        this.isTemplatesLoading = false;
        this.isFeedbackDataLoading = false;
        setTimeout(() => {
          this.showForm = true;
          this.trackOriginalAnswers();
          this.isLoadingFeedback.emit(false);
          this.reEvaluateDependenciesAfterPrefill();
          this.cdr.detectChanges();
        }, 0);
      },
      error: (err) => {
        this.isFeedbackDataLoading = false;
        this.isLoading = false;
        this.isLoadingFeedback.emit(false);
        this.setEmptyFormReady();
      }
    });
  }

  private populateFormFromFeedbackData(feedbackData: any) {
    this.templateCollections.forEach((section: any) => {
      section.forEach((model: FormModel) => {
        if (!feedbackData.hasOwnProperty(model.fieldValue)) return;
        const value = feedbackData[model.fieldValue];
        if (value === null) return;

        if (model.fieldType === 'dropdown') {
          if (typeof value === 'string' && (value.startsWith('{') || value.startsWith('['))) {
            try {
              const parsedValue = JSON.parse(value);
              if (parsedValue?.value != null) {
                model.answer = [{ label: parsedValue.label, value: parsedValue.value }];
                model.placeHolder = parsedValue.label;
              } else {
                model.answer = [value];
              }
            } catch {
              const opt = model.fieldOptions?.find((o: any) => o.value === value);
              model.answer = opt ? [opt] : [value];
              model.placeHolder = opt?.label;
            }
          } else {
            const opt = model.fieldOptions?.find((o: any) => o.value === value);
            model.answer = opt ? [opt] : [value];
            model.placeHolder = opt?.label;
          }
        } else if (model.fieldType === 'radio') {
          const opt = model.fieldOptions?.find((o: any) => o.value === value);
          model.answer = [value];
          model.placeHolder = opt?.label;
        } else if (['multi-dropdown', 'checkbox', 'multi-file'].includes(model.fieldType)) {
          model.answer = value || [];
        } else {
          model.answer = [value];
        }
        model.isValid = true;
        model.readOnly = false;
        model.disabled = false;
      });
    });
  }

  private setEmptyFormReady() {
    this.isLoading = false;
    this.isTemplatesLoading = false;
    this.isFeedbackDataLoading = false;
    this.showForm = true;
    this.trackOriginalAnswers();
    this.isLoadingFeedback.emit(false);
    this.cdr.detectChanges();
  }

  resetToCreateMode() {
    this.feedbackMode = 'create';
    this.skipDataPopulation = true;
    this.feedbackData = null;
    this.submissionId = 0;
    this.hasChanges = false;
    this.showForm = false;
    this.cdr.detectChanges();
    this.templateCollections.forEach((section: any) => {
      section.forEach((model: FormModel) => {
        model.answer = [];
        model.isValid = !model.isMandatory;
        model.readOnly = false;
        model.disabled = false;
      });
    });
    this.updateDependentField();
    this.reEvaluateDependenciesAfterPrefill();
    this.trackOriginalAnswers();
    setTimeout(() => {
      this.showForm = true;
      this.cdr.detectChanges();
    }, 0);
  }

  loadPanelMembersOnly() {
    this.eventServices.getFeedbackTestDetailsFastApi(this.candidateDetails.event_uuid, this.candidateDetails.candidate_uuid).subscribe({
      next: (res: any) => {
        if (res.body.feedback_details && res.body.feedback_details.length > 0) {
          const panelEntries = this.candidateDetails.showAllInterviews
            ? res.body.feedback_details.filter(
                (f: any) => f.stage_uuid === this.candidateDetails.stage_uuid
              )
            : (this.candidateDetails.interview_uuid
                ? res.body.feedback_details.filter(
                    (f: any) => f.interview_uuid === this.candidateDetails.interview_uuid
                  )
                : res.body.feedback_details.filter(
                    (f: any) => f.stage_uuid === this.candidateDetails.stage_uuid
                  ));
          this.panelMembersLoaded.emit(panelEntries);
        } else {
          this.panelMembersLoaded.emit([]);
        }
      },
      error: () => {
        this.panelMembersLoaded.emit([]);
      }
    });
  }

  loadPanelMemberFeedback(formId: number) {
    this.candidateDetails = { ...this.candidateDetails, form_id: formId };
    this.skipDataPopulation = false;
    this.showForm = false;
    this.isLoading = true;
    this.isFeedbackDataLoading = false;
    this.cdr.detectChanges();
    this.getFeedbackData();
  }

  private loadOfflinePanelMembers() {
    if (!this.candidateDetails?.event_uuid || !this.candidateDetails?.candidate_uuid || !this.candidateDetails?.interview_uuid) {
      this.isLoading = false;
      this.showForm = false;
      this.getTemplates();
      return;
    }
    this.loadingOfflinePanelMembers = true;
    this.offlinePanelMembers = [];
    this.eventServices.getFeedbackTestDetailsFastApi(this.candidateDetails.event_uuid, this.candidateDetails.candidate_uuid).subscribe({
      next: (res: any) => {
        this.loadingOfflinePanelMembers = false;
        const list = res?.body?.feedback_details || [];
        const interviewUuid = this.candidateDetails.interview_uuid;
        const forThisInterview = list.filter((f: any) => f.interview_uuid === interviewUuid);
        const currentUserIdNum = this.currentUserIdOffline != null ? Number(this.currentUserIdOffline) : null;
        this.offlinePanelMembers = forThisInterview.map((f: any) => ({
          submitted_by_id: f.submitted_by_id,
          submitted_by_name: f.submitted_by_name,
          submitted_date: f.submitted_date,
          form_id: f.form_id,
          isVirtual: false
        }));
        const currentUserEntry = this.offlinePanelMembers.find(
          (m: any) => currentUserIdNum != null && (Number(m.submitted_by_id) === currentUserIdNum || m.submitted_by_id == this.currentUserIdOffline)
        );
        if (!currentUserEntry) {
          this.offlinePanelMembers.unshift({
            submitted_by_id: this.currentUserIdOffline,
            submitted_by_name: this.currentUserNameOffline,
            submitted_date: null,
            form_id: null,
            isVirtual: true
          });
        } else {
          this.offlinePanelMembers.sort((a: any, b: any) => {
            if (Number(a.submitted_by_id) === currentUserIdNum || a.submitted_by_id == this.currentUserIdOffline) return -1;
            if (Number(b.submitted_by_id) === currentUserIdNum || b.submitted_by_id == this.currentUserIdOffline) return 1;
            return 0;
          });
        }
        const defaultMember = this.offlinePanelMembers.find((m: any) => Number(m.submitted_by_id) === currentUserIdNum || m.submitted_by_id == this.currentUserIdOffline) || this.offlinePanelMembers[0];
        this.selectedOfflinePanelMemberId = defaultMember?.submitted_by_id ?? null;
        this.selectedOfflinePanelMemberFormId = defaultMember?.form_id ?? null;
        this.candidateDetails = { ...this.candidateDetails, form_id: defaultMember?.form_id ?? undefined };
        this.isViewOnlyFeedbackOffline = false;
        this.feedbackMode = this.offlineOriginalFeedbackMode;
        this.isLoading = false;
        this.showForm = false;
        this.getTemplates();
        this.cdr.detectChanges();
      },
      error: () => {
        this.loadingOfflinePanelMembers = false;
        this.isLoading = false;
        this.showForm = false;
        this.getTemplates();
        this.cdr.detectChanges();
      }
    });
  }

  selectOfflinePanelMember(member: any) {
    if (this.selectedOfflinePanelMemberFormId === member.form_id && this.selectedOfflinePanelMemberId === member.submitted_by_id) return;
    this.selectedOfflinePanelMemberId = member.submitted_by_id;
    this.selectedOfflinePanelMemberFormId = member.isVirtual ? null : (member.form_id ?? null);
    this.candidateDetails = { ...this.candidateDetails, form_id: member.form_id ?? undefined };
    const isCurrentUser = this.isCurrentUserOffline(member);
    if (member.isVirtual) {
      this.feedbackMode = 'create';
      this.isViewOnlyFeedbackOffline = false;
      this.resetToCreateMode();
    } else {
      this.isViewOnlyFeedbackOffline = !isCurrentUser;
      this.feedbackMode = isCurrentUser ? this.offlineOriginalFeedbackMode : 'view';
      if (member.form_id) {
        this.loadPanelMemberFeedback(member.form_id);
      }
    }
    this.cdr.detectChanges();
  }

  isCurrentUserOffline(member: any): boolean {
    if (this.currentUserIdOffline == null || member?.submitted_by_id == null) return false;
    return Number(member.submitted_by_id) === Number(this.currentUserIdOffline) || member.submitted_by_id == this.currentUserIdOffline;
  }

  private refreshOfflinePanelMembers() {
    if (!this.candidateDetails?.event_uuid || !this.candidateDetails?.candidate_uuid || !this.candidateDetails?.interview_uuid) return;
    this.eventServices.getFeedbackTestDetailsFastApi(this.candidateDetails.event_uuid, this.candidateDetails.candidate_uuid).subscribe({
      next: (res: any) => {
        const list = res?.body?.feedback_details || [];
        const interviewUuid = this.candidateDetails.interview_uuid;
        const forThisInterview = list.filter((f: any) => f.interview_uuid === interviewUuid);
        const currentUserIdNum = this.currentUserIdOffline != null ? Number(this.currentUserIdOffline) : null;
        this.offlinePanelMembers = forThisInterview.map((f: any) => ({
          submitted_by_id: f.submitted_by_id,
          submitted_by_name: f.submitted_by_name,
          submitted_date: f.submitted_date,
          form_id: f.form_id,
          isVirtual: false
        }));
        const currentUserEntry = this.offlinePanelMembers.find(
          (m: any) => currentUserIdNum != null && (Number(m.submitted_by_id) === currentUserIdNum || m.submitted_by_id == this.currentUserIdOffline)
        );
        if (!currentUserEntry) {
          this.offlinePanelMembers.unshift({
            submitted_by_id: this.currentUserIdOffline,
            submitted_by_name: this.currentUserNameOffline,
            submitted_date: null,
            form_id: null,
            isVirtual: true
          });
        } else {
          this.offlinePanelMembers.sort((a: any, b: any) => {
            if (Number(a.submitted_by_id) === currentUserIdNum || a.submitted_by_id == this.currentUserIdOffline) return -1;
            if (Number(b.submitted_by_id) === currentUserIdNum || b.submitted_by_id == this.currentUserIdOffline) return 1;
            return 0;
          });
        }
        const currentUserMember = this.offlinePanelMembers.find((m: any) => Number(m.submitted_by_id) === currentUserIdNum || m.submitted_by_id == this.currentUserIdOffline);
        if (currentUserMember) {
          this.selectedOfflinePanelMemberId = currentUserMember.submitted_by_id;
          this.selectedOfflinePanelMemberFormId = currentUserMember.form_id ?? null;
          this.candidateDetails = { ...this.candidateDetails, form_id: currentUserMember.form_id ?? undefined };
        }
        this.cdr.detectChanges();
      }
    });
  }



  submit() {
    if (this.submitBtnLoading) return;
    this.clicked = true;
    let templateModels = this.templateCollections.flat(1);
    this.isFormValid = !templateModels.map((model: FormModel) => model.isValid).includes(false);

    if (this.isFormValid) {
      this.submitBtnLoading = true;
      let submitData = templateModels.reduce((acc: any, field: FormModel) => {
        if (field.fieldType === "paragraph") {
          return acc;
        }
        let value = (field.fieldType === "multi-dropdown" || field.fieldType === "checkbox" || field.fieldType === "multi-file") ? field.answer : (Array.isArray(field.answer) ? field.answer[0] ?? null : field.answer ?? null);
        
        // Extract value from object if it's a dropdown/radio option object
        if (value && typeof value === 'object' && value.hasOwnProperty('value')) {
          value = value.value;
        }
        
        acc[field.fieldValue] = value;
        return acc;
      }, {});      
      const fieldsToCheck = Object.keys(submitData).filter(key => typeof submitData[key] === 'string');
      let hasViolations = false;
      
      for (let fieldName of fieldsToCheck) {
        if (this.sharedService.hasSingleInputViolation(submitData[fieldName])) {
          hasViolations = true;
          break;
        }
      }
      
      if (this.feedbackMode === 'create' && !this.hasAnyData()) {
        this.messageServices.add({ severity: 'error', summary: 'Validation Error', detail: 'Please fill all the required fields' });
        this.submitBtnLoading = false;
        this.clicked = false;
        return;
      }

      if (this.feedbackMode === 'edit' && !this.hasChanges) {
        this.submitBtnLoading = false;
        this.clicked = false;
        return;
      }

      if (hasViolations) {
        this.messageServices.add({ 
          severity: 'error', 
          summary: 'Invalid Input', 
          detail: 'Invalid input format in some fields.' 
        });
        this.submitBtnLoading = false;
        return;
      }

      let payload = this.sharedService.getSecurePayload(submitData);
      payload.candidate_uuid = this.candidateDetails.candidate_uuid;
      if (this.feedbackMode === 'create') {
        this.saveFeedback(payload);
      } else if (this.feedbackMode === 'edit') {
        this.updateFeedback(payload);
      }
    } else {
      let invalidFields = templateModels.filter((model: FormModel) => !model.isValid);
      this.invalidField = invalidFields[0];
      this.messageServices.add({ severity: 'error', summary: 'Validation Error', detail: 'Please fill the required fields before submitting.' });
    }
  }

  hasAnyData(): boolean {
    const templateModels = this.templateCollections.flat(1).filter((eachModel: FormModel) => eachModel.visible);
    return templateModels.some((model: FormModel) => {
      const value = Array.isArray(model.answer) ? model.answer[0] : model.answer;
      return value !== null && value !== undefined && value !== '';
    });
  }

  saveFeedback = (payload: any) => {   
    this.formBuilderServices.submitFeedbackFormFastApi(payload, this.candidateDetails.event_uuid, this.candidateDetails.stage_uuid, this.candidateDetails.interview_uuid).subscribe({
      next: (res: any) => {
        this.messageServices.add({ severity: 'success', summary: 'Success', detail: 'Feedback Submitted Successfully.' });
        this.submitBtnLoading = false;
        this.clicked = false;
        if (this.interviewMode === 'Offline') {
          this.feedbackSubmitted = true;
          this.feedbackStatus = true;
          this.showForm = false;
          const url = new URL(window.location.href);
          url.searchParams.set('feedback_status', 'true');
          window.history.replaceState({}, '', url);
          this.refreshOfflinePanelMembers();
        } else {
          setTimeout(() => {
            this.closeFeedbackSlider.emit(true);
          }, 1500);
        }
      },
      error: (err) => {
        // this.messageServices.add({ severity: 'error', summary: 'Failed', detail: 'Something went wrong!' });
        this.submitBtnLoading = false;
        this.clicked = false;
      }
    });
  }

  updateFeedback = (payload: any) => {
    this.submitBtnLoading = true;
    this.formBuilderServices.UpdateFormFastApi(payload, this.candidateDetails.event_uuid, 'feedback', this.submissionId).subscribe({
      next: (res: any) => {
        this.messageServices.add({ severity: 'success', summary: 'Success', detail: 'Feedback Updated Successfully.' });
        this.submitBtnLoading = false;
        this.clicked = false;
        this.hasChanges = false; // Reset changes flag
        this.trackOriginalAnswers(); // Re-track original answers after update
        if (this.interviewMode === 'Offline') {
          this.feedbackStatus = true;
          this.feedbackSubmitted = true;
          this.showForm = false;
          this.refreshOfflinePanelMembers();
        } else {
          setTimeout(() => {
            this.closeFeedbackSlider.emit(true);
          }, 1500);
        }
      },
      error: (err) => {
        this.messageServices.add({ severity: 'error', summary: 'Failed', detail: 'Something went wrong!' });
        this.submitBtnLoading = false;
        this.clicked = false;
      }
    });
  }


  checkForDependancy = (model: FormModel): boolean => {
    if (model.dependant) {
      let templateModels = this.templateCollections.flat(1);
      let dependantField: any;

      templateModels.forEach((eachModel: FormModel) => {
        if (eachModel.fieldName === model.dependant?.dependantOn) dependantField = eachModel;
      })
      if (model.dependant.dependantValues.includes(dependantField.answer[0])) {
        model.visible = true;
        return true;
      }
      else {
        model.visible = false;
        model.answer = [];
        model.isValid = model.isMandatory ? false : true;
        return false;
      }
    } else return true;
  }


  downloadFeedback = () => {
    this.downloadFeedbackEvent.emit();
    if (this.feedbackData) {
      const verticalData = Object.entries(this.feedbackData)
        .filter(([_, value]) => value !== null)
        .map(([key, value]) => {
          let fieldModel = null;
          for (const section of this.templateCollections) {
            fieldModel = section.find(model => model.fieldValue === key);
            if (fieldModel) break;
          }
          
          const displayValue = fieldModel && fieldModel.fieldOptions?.length 
            ? this.getFieldValueLabel(value, fieldModel.fieldOptions)
            : value;
            
          return {
            'Field Name': key
              .split('_')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' '),
            'Value': displayValue
          };
        });
  
      import("xlsx").then(XLSX => {
        const worksheet = XLSX.utils.json_to_sheet(verticalData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Feedback");

        const wscols = [
          { wch: 40 }, // Field Name column
          { wch: 40 }  // Value column
        ];
        worksheet['!cols'] = wscols;
  
        const excelBuffer = XLSX.write(workbook, { 
          bookType: "xlsx", 
          type: "array" 
        });
        
        const fileName = `${this.feedbackData.candidate_uuid || 'candidate'}_feedback.xlsx`;
        const blob = new Blob([excelBuffer], { 
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
        });
        
        saveAs(blob, fileName);
      });
    }
  }

  enableEditMode() {
    this.feedbackSubmitted = false;
    this.feedbackMode = 'edit';
    this.showForm = true;
    this.getFeedbackData();
  }

  getFieldValueLabel(fieldValue: any, fieldOptions: any[]): any {
    if (!fieldValue || fieldValue === '') return '-';
    if (!fieldOptions?.length) return fieldValue;
    
    if (Array.isArray(fieldValue)) {
      if (fieldValue.length === 0) return '-';
      return fieldValue.map(val => {
        const option = fieldOptions.find(opt => opt.value == val);
        return option ? option.label : val;
      }).join(', ');
    }
    
    const option = fieldOptions.find(opt => opt.value == fieldValue);
    return option ? option.label : fieldValue;
  }

  getInitials(fullName: string): string {
    if (!fullName) return 'UN';
    
    const names = fullName.trim().split(' ');
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    
    const firstInitial = names[0].charAt(0).toUpperCase();
    const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
    return firstInitial + lastInitial;
  }
  
  getAvatarColor(name: string): string {
    const colors = [
      '#FF6B35', '#F7931E', '#FFD23F', '#06FFA5', '#1FB6FF', '#7209B7',
      '#F93A13', '#FF8C42', '#FFE66D', '#4ECDC4', '#45B7D1', '#96CEB4',
      '#FECA57', '#FF9FF3', '#54A0FF', '#5F27CD', '#00D2D3', '#FF9FF3',
      '#FFB8B8', '#C44569', '#F8B500', '#A55EEA', '#26C0C7', '#FF3838',
      '#FF6B6B', '#4834D4', '#686DE0', '#30336B', '#95E1D3', '#F8B500'
    ];
    
    if (!name) return colors[0];
    
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    return colors[Math.abs(hash) % colors.length];
  }

  setProfileImage(): void {
    if (this.candidateDetails?.profilePic) {
      if (this.candidateDetails.profilePic.startsWith('http')) {
        this.signedProfileUrl = this.candidateDetails.profilePic;
      } else {
        this.signedProfileUrl = this.candidateDetails.profilePic;
      }
    } else {
      this.signedProfileUrl = '';
    }
  }

  // Change tracking methods
  trackOriginalAnswers(): void {
    this.originalAnswers = {};
    this.templateCollections.forEach(section => {
      section.forEach(field => {
        this.originalAnswers[field.fieldValue] = field.answer ? [...field.answer] : [];
      });
    });
  }

  checkForChanges(): void {
    let hasChanges = false;
    this.templateCollections.forEach(section => {
      section.forEach(field => {
        const originalAnswer = this.originalAnswers[field.fieldValue] || [];
        const currentAnswer = field.answer || [];
        
        if (JSON.stringify(originalAnswer) !== JSON.stringify(currentAnswer)) {
          hasChanges = true;
        }
      });
    });
    this.hasChanges = hasChanges;
  }

  resetFormToOriginalState(): void {
    this.templateCollections.forEach(section => {
      section.forEach(field => {
        const originalAnswer = this.originalAnswers[field.fieldValue];
        if (originalAnswer !== undefined) {
          field.answer = [...originalAnswer];
        } else {
          field.answer = [];
        }
      });
    });
    this.hasChanges = false;
  }

  bindData(event: any, model: FormModel): void {
    model.answer = [];
    
    switch (model.fieldType) {
      case 'checkbox':
        model.answer = event;
        break;
      case 'multi-dropdown':
        model.answer = event;
        break;
      case 'dropdown': 
        // For dropdown, keep the full object for display (shows label), but submit extracts value
        model.answer.push(event);
        break;
      case 'input':
      case 'textarea':
      case 'email':
      case 'number':
      case 'percentage':
        model.answer.push(event);
        break;
      case 'radio':
      case 'booleanRadio':
        // For radio, just store the value (not object)
        if (event && typeof event === 'object' && event.hasOwnProperty('value')) {
          model.answer.push(event.value);
        } else {
          model.answer.push(event);
        }
        break;
      case 'mobile':
        model.answer = event;
        break;
      case 'date picker':
        model.answer.push(event);
        break;
      case 'file':
      case 'multi-file':
        model.answer = event;
        break;
      default:
        model.answer.push(event);
    }
    this.checkForChanges();

    this.checkCanShowDependentField(model);
  }

  checkValid(event: boolean, model: FormModel): void {
    model.isValid = event;
  }

  trackByFieldId(index: number, field: FormModel): string {
    return field.fieldId;
  }

  getSubmitButtonLabel(): string {
    if (this.interviewMode === 'Offline' && !this.feedbackStatus) {
      return 'Submit and End Interview';
    }
    
    if (this.feedbackMode === 'create') {
      return 'Submit';
    }
    
    return 'Update';
  }

  ngOnDestroy(): void {
    this.markAsTouced.complete();
  }

  private reEvaluateDependenciesAfterPrefill() {
        this.templateCollections?.forEach((section) => {
            section?.forEach((field) => {
                // Only re-evaluate fields that have answers and have dependencies defined
                if (field.answer && field.answer.length && field.dependencies && field.dependencies.length) {
                    this.checkCanShowDependentField(field);
                }
            });
        });
    }
  
  getDependenciesFields() {
    const allDependencies: Set<string> = new Set();
    this.templateCollections?.forEach((section) => {
      section?.forEach((field) => {
        const dependencies = field.dependencies || [];
        dependencies.forEach((dependency) => {
          dependency.show_fields.forEach((field) => {
            allDependencies.add(field);
          })
        })
      })
    })
    return allDependencies;
  }

  getAllFieldsMap(): Map<string, FormModel> {
    const map = new Map<string, FormModel>();
    this.templateCollections?.forEach(section => {
      section?.forEach(field => {
        map.set(field.fieldValue, field);
      });
    });
    return map;
  }

  updateDependentField() {
    this.dependenciesFields = this.getDependenciesFields();
    this.fieldsMap = this.getAllFieldsMap();
    
    this.templateCollections?.forEach((section) => {
      section?.forEach((field) => {
        if (this.dependenciesFields.has(field.fieldValue)) {
          field.visible = false;
          field.isMandatory = false;
          field.isValid = true;
        }
      })
    })
  }

  dependenciesFields: Set<string> = new Set();
  fieldsMap: Map<string, FormModel> = new Map();
  /**
   * Computes the global visibility for all dependent fields across all parent fields.
   * This ensures proper handling when multiple fields control the same dependent field.
   */
  private computeGlobalFieldVisibility(): Map<string, boolean> {
    const globalVisibility = new Map<string, boolean>();

    // First pass: collect all dependent fields and initialize them as hidden
    this.dependenciesFields.forEach(fieldId => {
      globalVisibility.set(fieldId, false);
    });

    // Second pass: check all parent fields and their dependencies
    this.templateCollections?.forEach((section) => {
      section?.forEach((field) => {
        if (!["dropdown", "radio", "checkbox", "multi-dropdown"].includes(field.fieldType)) return;
        if (!field.dependencies || field.dependencies.length === 0) return;

        const selectedOption = ["checkbox", "multi-dropdown"].includes(field.fieldType)
          ? field.answer
          : (field.answer?.[0]?.value || field.answer[0] || "");

        field.dependencies.forEach(dep => {
          const matches = Array.isArray(selectedOption)
            ? selectedOption.some((opt: any) => {
              const optValue = typeof opt === 'object' ? opt.value : opt;
              return optValue === dep.option;
            })
            : dep.option === selectedOption;

          if (matches) {
            // If any parent shows a field, mark it as visible (OR logic)
            (dep.show_fields || []).forEach(fid => {
              globalVisibility.set(fid, true);
            });
          }
        });
      });
    });

    return globalVisibility;
  }

  /**
   * Updates visibility of dependent fields based on the selected dropdown option.
   * Handles multi-level (nested) dependencies recursively.
   */
  checkCanShowDependentField(model: FormModel, visited = new Set<string>()) {
    // Only handle dropdown-type fields for now
    if (!["dropdown", "radio", "checkbox", "multi-dropdown"].includes(model.fieldType)) return;

    // Compute global visibility for all fields
    const globalVisibility = this.computeGlobalFieldVisibility();

    // Apply visibility to all dependent fields
    globalVisibility.forEach((shouldShow, fieldId) => {
      const field = this.fieldsMap.get(fieldId);
      if (!field) return;

      // Prevent infinite recursion in circular dependencies
      if (visited.has(fieldId)) return;

      if (shouldShow) {
        // Show Field
        if (!field.visible) {
          field.visible = true;
          field.isMandatory = field.is_required ? true : false;
          field.isValid = this.feedbackMode === 'view' ? true : !field.is_required;
        }

        // Mark visited before recursive check
        visited.add(fieldId);

        // Recursively check nested dependencies for this field
        if (field.dependencies && field.dependencies.length) {
          this.checkCanShowDependentField(field, visited);
        }

        // Remove from visited after recursion completes
        visited.delete(fieldId);

      } else {
        // Hide field only if no other parent field wants it visible
        if (field.visible || (field.answer && field.answer.length)) {
          field.visible = false;
          field.answer = []; // clear value
          field.isValid = true;

          // Recursively hide its child dependents
          this.hideNestedDependentFields(field, this.fieldsMap);
        }
      }
    });
  }

  /**
   * Recursively hides all dependent fields (and their children)
   * when a parent field is hidden.
   */
  hideNestedDependentFields(field: FormModel, allFieldsMap: Map<string, FormModel>, visited = new Set<string>()) {
    // Avoid re-processing the same field in circular dependencies
    if (!field?.dependencies || visited.has(field.fieldId)) return;

    visited.add(field.fieldId);

    field.dependencies.forEach(dep => {
      (dep.show_fields || []).forEach(depFieldId => {
        const depField = allFieldsMap.get(depFieldId);
        if (depField) {
          depField.visible = false;
          depField.answer = []; // clear hidden field value
          depField.isValid = true;
          // Recursively hide deeper nested dependents
          this.hideNestedDependentFields(depField, allFieldsMap, visited);
        }
      });
    });

    visited.delete(field.fieldId);
  }


  canShowSection(section: FormModel[]) {
    return section.some((field) => field.visible === true)
  }
}
